import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLightBoxesComponent } from './components/lightboxes/default/default.component';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { SidebarSkeletonComponent } from './components/sidebar-skeleton/sidebar-skeleton.component';
import { UIToolkitModule } from '../ui-toolkit/ui-toolkit.module';
import { CategoriaCardComponent } from './components/categoria-card/categoria-card.component';
import { ProdutoDoPlanoCard } from './components/produto-do-plano-card/produto-do-plano-card.component';
import { VideoComponent } from './components/video/video.component';
import { SafePipe } from './pipes/SafePipe.pipe';
import { UFFilterListComponent } from './components/uf-filter-list/uf-filter-list.component';
import { CompanySignatureComponent } from './components/company-signature/company-signature.component';
import { HeaderMobileComponent } from './components/header-mobile/header-mobile.component';


@NgModule({
  declarations: [
    DefaultLightBoxesComponent,
    SidebarItemComponent,
    SidebarSkeletonComponent,
    CategoriaCardComponent,
    ProdutoDoPlanoCard,
    VideoComponent,
    SafePipe,
    UFFilterListComponent,
    CompanySignatureComponent,
    HeaderMobileComponent
  ],
  imports: [
    CommonModule,
    UIToolkitModule,
  ],
  exports: [
    DefaultLightBoxesComponent,
    SidebarItemComponent,
    SidebarSkeletonComponent,
    CategoriaCardComponent,
    ProdutoDoPlanoCard,
    VideoComponent,
    SafePipe,
    UFFilterListComponent,
    CompanySignatureComponent,
    HeaderMobileComponent
  ]
})
export class SharedModule { }
